module.exports = __webpack_public_path__ + "img/icon-editoras.e0594442.svg";